export function getAmountOfCodeUnits(string: string): number {
	return string.length;
}
